import { defineMessages } from 'react-intl';

export default defineMessages({
  recap: {
    id: 'expert_mission.recap',
  },
  expertise: {
    id: 'expert_mission.expertise',
  },
});
